import React from "react";
import { Briefcase } from "@phosphor-icons/react";
import { Panel, Empty } from "./_shared";

export default function PositionControl({ staff }) {
  const byDept = {};
  staff.forEach((s) => {
    const d = s.department || "Unassigned";
    byDept[d] = byDept[d] || { permanent: 0, project_based: 0 };
    byDept[d][s.staff_type === "permanent" ? "permanent" : "project_based"]++;
  });
  return (
    <Panel title="Position & Vacancy Control" icon={<Briefcase size={16} style={{ color: "#1E5CBA" }} />}>
      <table className="w-full">
        <thead className="bg-slate-50 text-left text-[11px] font-mono-alt uppercase tracking-widest text-slate-500">
          <tr><th className="px-5 py-3">Department</th><th className="px-5 py-3">Permanent</th><th className="px-5 py-3">Project-Based</th><th className="px-5 py-3">Total</th></tr>
        </thead>
        <tbody className="divide-y divide-slate-100">
          {Object.entries(byDept).map(([d, v]) => (
            <tr key={d} className="text-sm">
              <td className="px-5 py-3 font-semibold text-slate-900">{d}</td>
              <td className="px-5 py-3 font-mono-alt">{v.permanent}</td>
              <td className="px-5 py-3 font-mono-alt">{v.project_based}</td>
              <td className="px-5 py-3 font-mono-alt font-semibold">{v.permanent + v.project_based}</td>
            </tr>
          ))}
          {Object.keys(byDept).length === 0 && <tr><td colSpan={4}><Empty text="No staff in the system yet." /></td></tr>}
        </tbody>
      </table>
    </Panel>
  );
}
